import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchFactoriesList} from 'api';
import {rootDomain} from 'core/rootDomain';
import {FactoriesListRawRow} from 'types/profile';

const domain = rootDomain.createDomain('ProfileFactoriesDomain');
export const Gate = createGate('ProfileFactoriesGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchFactoriesDataFx',
    handler: fetchFactoriesList,
});

export const data$ = domain.createStore<FactoriesListRawRow[]>([]);

export const factoriesState$ = combine({
    data: data$,
    isLoading: fetchDataFx.pending,
});
